import { Model } from "survey-core";
import { setProperty } from "dot-prop";

export const buildPayload = (survey: Model) => {
  const payload: Record<string, unknown> = {};

  survey.getAllQuestions().forEach((question) => {
    const path = (question as any).payloadPath;
    if (!path) return; // Questions without a payloadPath are ignored
    if (
      !question.visible &&
      question.visibleIf !== "" &&
      question.clearIfInvisible !== "none"
    )
      return; // Hidden questions (e.g. via visibleIf) are excluded unless explicitly kept

    const value = survey.data[question.name];
    if (value === undefined) return;
    setProperty(payload, path, value);
  });

  survey.calculatedValues.forEach((calc) => {
    const path = (calc as any).jsonObj.payloadPath;

    const value = calc.value;
    if (!path || value === undefined) return; // Calculated values without a payloadPath are ignored
    setProperty(payload, path, value);
  });

  return payload;
};
